export const GithubRepoDemo = [
    {
        id: 594660735,
        name: 'php-tools',
        fullName: 'bikirandev/php-tools',
        private: false,
        createdAt: '2023-01-29T08:35:19Z',
        updatedAt: '2023-01-29T08:43:44Z',
        releaseUrl: 'https://api.github.com/repos/bikirandev/php-tools/releases{/id}',
        owner: {
            id: 110200264,
            login: 'bikirandev',
            avatarUrl: 'https://avatars.githubusercontent.com/u/110200264?v=4'
        },
        demo: true
    },
    {
        id: 636269132,
        name: 'react-electron',
        fullName: 'bikirandev/react-electron',
        private: false,
        createdAt: '2023-05-04T13:24:51Z',
        updatedAt: '2023-05-04T13:24:51Z',
        releaseUrl: 'https://api.github.com/repos/bikirandev/react-electron/releases{/id}',
        owner: {
            id: 110200264,
            login: 'bikirandev',
            avatarUrl: 'https://avatars.githubusercontent.com/u/110200264?v=4'
        },
        demo: true
    },
    {
        id: 23157485,
        name: '00-bikiran',
        fullName: 'bishojit/00-bikiran',
        private: false,
        createdAt: '2014-08-20T17:28:12Z',
        updatedAt: '2023-05-20T12:22:14Z',
        releaseUrl: 'https://api.github.com/repos/bishojit/00-bikiran/releases{/id}',
        owner: {
            id: 8505383,
            login: 'bishojit',
            avatarUrl: 'https://avatars.githubusercontent.com/u/8505383?v=4'
        },
        demo: true
    }
];

export default null;
